// extracted by mini-css-extract-plugin
module.exports = {"links":"ViewSwapper_links__2NhHN","active":"ViewSwapper_active__u3xmi","shown":"ViewSwapper_shown__HMXqP","hidden":"ViewSwapper_hidden__nc6wK"};